import { IconCopy as TablerIconCopy } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconCopy = /*#__PURE__*/ createOutlineIcon(TablerIconCopy, 'IconCopy');
